import CollectiveRiskReport from './components/CollectiveRiskReport';
import PersonalRiskReport from './components/PersonalRiskReport';

export default function Hsp2({
  filters, reportData, selectedToggleOption, networkSelector, dataCategories,
}) {
  if (selectedToggleOption?.report_type?.[0] === 'Personal') {
    return (
      <PersonalRiskReport
        dataCategories={dataCategories}
        filters={filters}
        reportData={{ ...reportData, data: [...reportData.data.filter((x) => x.measureCode === selectedToggleOption?.measureCode?.[0])] }}
        networkSelector={networkSelector}
      />
    );
  }

  return (
    <CollectiveRiskReport
      dataCategories={dataCategories}
      filters={filters}
      reportData={{ ...reportData, data: [...reportData.data.filter((x) => x.measureCode === selectedToggleOption?.measureCode?.[0])] }}
      networkSelector={networkSelector}
    />
  );
}
